import React from "react";
import {
    RenderKilogramo,
    RenderNumberPercentage,
} from "../../../../../../Utils/renderField/renderReadField";
import NullableValue from "../../../../../../Utils/renderField/nullableValue";
import moment from "moment";

export const TotalesIndividualRow = ({ totalesTraslados = {} }) => {
    return (
        <tr className="totales-row">
            <td className="text-center text-nowrap cell-border-right">
                <strong>TOTALES</strong>
            </td>
            {/* ACOPIO */}
            <td></td>
            <td className="text-center text-nowrap">
                <NullableValue value={totalesTraslados.acopio_kg_humedo}>
                    <RenderKilogramo
                        value={totalesTraslados.acopio_kg_humedo}
                    />
                </NullableValue>
            </td>
            <td className="text-center text-nowrap">
                <NullableValue value={totalesTraslados.acopio_kg_seco_lab}>
                    <RenderKilogramo
                        value={totalesTraslados.acopio_kg_seco_lab}
                    />
                </NullableValue>
            </td>
            <td className="text-center text-nowrap">
                {totalesTraslados.acopio_drc_lab ? (
                    <RenderNumberPercentage
                        value={totalesTraslados.acopio_drc_lab}
                    />
                ) : (
                    "—"
                )}
            </td>
            <td className="text-center text-nowrap">
                <NullableValue value={totalesTraslados.acopio_kg_hum_salida}>
                    <RenderKilogramo
                        value={totalesTraslados.acopio_kg_hum_salida}
                    />
                </NullableValue>
            </td>
            <td className="text-center text-nowrap cell-border-right">
                <NullableValue
                    value={totalesTraslados.diferencia_hum_transporte}
                >
                    <RenderKilogramo
                        value={totalesTraslados.diferencia_hum_transporte}
                    />
                </NullableValue>
            </td>
            {/* ERSA */}
            <td className="text-center text-nowrap">
                <NullableValue value={totalesTraslados.planta_kg_humedo}>
                    <RenderKilogramo
                        value={totalesTraslados.planta_kg_humedo}
                    />
                </NullableValue>
            </td>
            <td className="text-center text-nowrap">
                <NullableValue value={totalesTraslados.planta_kg_seco_lab}>
                    <RenderKilogramo
                        value={totalesTraslados.planta_kg_seco_lab}
                    />
                </NullableValue>
            </td>
            <td className="text-center text-nowrap cell-border-right">
                {totalesTraslados.planta_drc_lab ? (
                    <RenderNumberPercentage
                        value={totalesTraslados.planta_drc_lab}
                    />
                ) : (
                    "—"
                )}
            </td>
            {/* LIQUIDACIÓN */}
            <td className="text-center text-nowrap">
                <NullableValue value={totalesTraslados.liquidacion_kg_seco}>
                    <RenderKilogramo
                        value={totalesTraslados.liquidacion_kg_seco}
                    />
                </NullableValue>
            </td>
            <td className="text-center text-nowrap cell-border-right">
                {totalesTraslados.liquidacion_drc_real ? (
                    <RenderNumberPercentage
                        value={totalesTraslados.liquidacion_drc_real}
                    />
                ) : (
                    "—"
                )}
            </td>

            {/* DIFERENCIA ERSA */}
            <td className="text-center text-nowrap">
                <NullableValue value={totalesTraslados.diferencia_acopio_lab}>
                    <RenderKilogramo
                        value={totalesTraslados.diferencia_acopio_lab}
                    />
                </NullableValue>
            </td>
            <td className="text-center text-nowrap cell-border-right">
                <NullableValue value={totalesTraslados.diferencia_liquidado}>
                    <RenderKilogramo
                        value={totalesTraslados.diferencia_liquidado}
                    />
                </NullableValue>
            </td>
            {/* VARIACIÓN ERSA */}
            <td className="text-center text-nowrap">
                <NullableValue value={totalesTraslados.variacion_acopio_lab}>
                    <RenderNumberPercentage
                        value={totalesTraslados.variacion_acopio_lab}
                    />
                </NullableValue>
            </td>
            <td className="text-center text-nowrap cell-border-right">
                <NullableValue value={totalesTraslados.variacion_liquidado}>
                    <RenderNumberPercentage
                        value={totalesTraslados.variacion_liquidado}
                    />
                </NullableValue>
            </td>

            {/* PÉRDIDA DE AGUA */}
            <td className="text-center text-nowrap">
                <NullableValue value={totalesTraslados.perdida_agua}>
                    <RenderNumberPercentage
                        value={totalesTraslados.perdida_agua}
                    />
                </NullableValue>
            </td>
        </tr>
    );
};
